export const formatCompact = (number) =>
  number < 1000
    ? number
    : Intl.NumberFormat("en-US", {
        notation: "compact",
        maximumFractionDigits: 1,
        minimumFractionDigits: 1,
      }).format(number);

export const formatNumber = (number) =>
  Intl.NumberFormat("en-US", {
    maximumFractionDigits: 1,
  }).format(number);

export const formatPercentage = (number, decimals = 0) =>
  Intl.NumberFormat("en-US", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(number);
